import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, switchMap } from 'rxjs';
import { usersActions } from '../actions/users.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class UsersEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getUsers$ = createEffect(() => {
        return this.actions.pipe(
            ofType(usersActions.getUsers),
            switchMap(({ value }) => {
                return this.httpService.getUsers(value).pipe(
                    map((payload) => usersActions.getUsersSuccess({ payload })),
                    catchError((response: HttpErrorResponse) => of(usersActions.getUsersError({ code: response.status }))),
                );
            }),
        );
    });

    getUsersLookup$ = createEffect(() => {
        return this.actions.pipe(
            ofType(usersActions.getUsersLookup),
            switchMap(() => {
                return this.httpService.getUsersLookup().pipe(
                    map((payload) => usersActions.getUsersLookupSuccess({ payload })),
                    catchError((response: HttpErrorResponse) => of(usersActions.getUsersLookupError({ code: response.status }))),
                );
            }),
        );
    });
}
